import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home-img.png'


const _withScopeId = n => (_pushScopeId("data-v-42f9aed1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7 col-md-12 d-flex flex-column justify-content-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "btn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 col-md-12 part2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-100",
    src: _imports_0,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", {
            innerHTML: _ctx.content,
            class: "pre-wrap"
          }, null, 8, _hoisted_5),
          _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("buttons.learnMore")), 1)
        ]),
        _hoisted_7
      ])
    ])
  ]))
}